<template>
  <div>
    <h1 class="util--screen-reader">{{ t("routes.company.name") }}</h1>
    <div class="content-grid">
      <MemberOrganizationForm :organization-id="member.organizationId"/>
    </div>
  </div>
</template>

<script lang="ts" setup>
import {useI18n} from "vue3-i18n"
import {useMemberStore} from "@/stores/memberStore";
import MemberOrganizationForm from "@/views/member/MemberOrganizationForm.vue";

const {t} = useI18n()
const memberStore = useMemberStore()
const member = memberStore.getMember;

</script>
    